import { combineReducers } from 'redux';

import * as actionTypes from '../action-mgr/actionTypes';

import { aggregations, colorList } from '../../helpers/constants';

const yearIndices = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_YEAR_INDICES_SUCCESS:
      return action.yearIndices;
    default:
      return state;
  }
}

const findStationFields = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS:
      return action.findStationFields;
    default:
      return state;
  }
}

const stationId = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return action.stationId;
    default:
      return state;
  }
}

const stationGraphFields = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.SELECT_STATION:
      return {};
    case actionTypes.FETCH_GRAPH_REF_SUCCESS:
      return action.fieldVisibleMapping;
    case actionTypes.TOGGLE_FIELD:
      return {
        ...state,
        [action.fieldName]: !state[action.fieldName]
      };
    default:
      return state;
  }
}

const selectedView = (state = "day", action) => {
  switch (action.type) {
    case actionTypes.SELECT_VIEW_PERIOD:
      return action.view;
    default:
      return state;
  }
}

const records = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_MONTH_DATA_SUCCESS:
    case actionTypes.FETCH_YEAR_DATA_SUCCESS:
    case actionTypes.FETCH_DAY_DATA_SUCCESS:
      return action.data;
    case actionTypes.SELECT_VIEW_PERIOD:
    case actionTypes.SELECT_YEAR:
    case actionTypes.SELECT_MONTH:
    case actionTypes.SELECT_DAY:
    case actionTypes.SELECT_STATION:
      return [];
    default:
      return state;
  }
}

//new Date().getDate()
const selectedDay = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_DAY:
      return action.day;
    default:
      return state;
  }
}

//new Date().getMonth() + 1
const selectedMonth = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_MONTH:
      return action.month;
    default:
      return state;
  }
}

//new Date().getFullYear()
const selectedYear = (state = "", action) => {
  switch (action.type) {
    case actionTypes.SELECT_YEAR:
      return action.year;
    default:
      return state;
  }
}

const selectedAgg = (state = aggregations[0].value, action) => {
  switch (action.type) {
    case actionTypes.SELECT_AGG:
      return action.agg;
    default:
      return state;
  }
}

const isFetching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_MONTH_DATA_REQUEST:
    case actionTypes.FETCH_YEAR_DATA_REQUEST:
    case actionTypes.FETCH_DAY_DATA_REQUEST:
      return true;
    case actionTypes.FETCH_MONTH_DATA_FAILURE:
    case actionTypes.FETCH_YEAR_DATA_FAILURE:
    case actionTypes.FETCH_DAY_DATA_FAILURE:
    case actionTypes.FETCH_MONTH_DATA_SUCCESS:
    case actionTypes.FETCH_YEAR_DATA_SUCCESS:
    case actionTypes.FETCH_DAY_DATA_SUCCESS:
      return false;
    default:
      return state;
  }
}

const isGraphReferenceFetching = (state = false, action) => {
  switch (action.type) {
    case actionTypes.FETCH_GRAPH_REF_REQUEST:
      return true;
    case actionTypes.FETCH_GRAPH_REF_SUCCESS:
    case actionTypes.FETCH_GRAPH_REF_FAILURE:
      return false;
    default:
      return state;
  }
}

const graphReferences = (state = [], action) => {
  switch (action.type) {
    case actionTypes.FETCH_GRAPH_REF_SUCCESS:
      return action.data;
    default:
      return state;
  }
}

const stationTimeOffset = (state = null, action) => {
  var targetDate = new Date();
  return targetDate.valueOf()
}

const queryHistoryData = (state = [], action) => {
  switch (action.type) {
    case actionTypes.GET_QUERY_HISTORY_SUCCESS:
      return JSON.parse(action.queryHistoryData.replace("/[][]/g", ''));
    case actionTypes.RESET_SELECT_FIELDS:
      return []
    default:
      return state;
  }
}

const selectFields = (state = [], action) => {
  switch (action.type) {
    case actionTypes.SELECT_FIELDS:
      return (state.indexOf(action.selectFields) > -1) ?
        [
          ...state.slice(0, state.indexOf(action.selectFields)),
          ...state.slice(state.indexOf(action.selectFields) + 1)
        ] :
        [
          ...state,
          action.selectFields
        ]
    case actionTypes.RESET_SELECT_FIELDS:
      return [];
    case actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS:
      let defautlSelect = []
      let counter = 0;
      if (action.findStationFields) {
        Object.entries(action.findStationFields).forEach(([key, value], index) => {
          if (counter < 3 && value !== "") {
            defautlSelect.push(key)
            counter++;
          }
        });
      }
      return defautlSelect
    default:
      return state;
  }
}

const selectFieldsIndex = (state = ["1", "2", "3"], action) => {
  switch (action.type) {
    case actionTypes.SELECT_FIELDS_INDEX:
      return (state.indexOf(action.selectFieldsIndex) > -1) ?
        [
          ...state.slice(0, state.indexOf(action.selectFieldsIndex)),
          ...state.slice(state.indexOf(action.selectFieldsIndex) + 1)
        ] :
        [
          ...state,
          action.selectFieldsIndex
        ]
    case actionTypes.RESET_SELECT_FIELDS:
      return state = ["1", "2", "3"];
    case actionTypes.GET_FIND_STATIONS_FIELDS_SUCCESS:
      return state = ["1", "2", "3"]
    default:
      return state;
  }
}

export default combineReducers({
  stationId,
  selectedView,
  records,
  isFetching,
  selectedYear,
  selectedMonth,
  findStationFields,
  queryHistoryData,
  selectedAgg,
  selectFields,
  selectFieldsIndex,
  graphReferences,
  stationGraphFields,
  isGraphReferenceFetching,
  yearIndices,
  selectedDay,
  stationTimeOffset
});

const getCurrentState = state => state.slowData;

export const getStationTimeOffset = state => getCurrentState(state).stationTimeOffset;

export const getStationId = state => getCurrentState(state).stationId;

export const getSelectedYear = state => getCurrentState(state).selectedYear;

export const getSelectedAgg = state => getCurrentState(state).selectedAgg;

export const getSelectedField = state => getCurrentState(state).selectFields;

export const getSelectFieldsIndex = state => getCurrentState(state).selectFieldsIndex;

export const getSelectedMonth = state => getCurrentState(state).selectedMonth;

export const getRawData = state => getCurrentState(state).records;

export const getGraphDataSourceV2 = state => {

  const { queryHistoryData, selectFields } = getCurrentState(state);

  if (selectFields.length > 0) {
    var lables = ["Time"];
    let colors = colorList;

    if (queryHistoryData[0] !== undefined) {
      var obj_label = Object.keys(queryHistoryData[0]);
      obj_label.pop();
      lables = lables.concat(obj_label)
    }


    let data = queryHistoryData.map(historyData => {
      let item = [
        new Date(historyData.timestamp)
      ];

      var obj_arr = Object.values(historyData);
      obj_arr.pop();

      let hData = item.concat(obj_arr.map(Number));
      return hData;
    });

    return {
      lables,
      data,
      colors
    };
  } else {
    return {
      lables: [],
      data: [],
      colors: []
    };
  }


}

export const getSelectedView = state => getCurrentState(state).selectedView;

export const getIsFetching = state => getCurrentState(state).isFetching;

export const getGraphReferences = state => getCurrentState(state).graphReferences;

export const getStationGraphFields = state => getCurrentState(state).stationGraphFields;

export const getIsGraphReferenceFetching = state => getCurrentState(state).isGraphReferenceFetching;

export const getYearIndices = state => getCurrentState(state).yearIndices;

export const getSelectedDay = state => getCurrentState(state).selectedDay;

export const getFindStationFields = state => getCurrentState(state).findStationFields;

export const getqueryHistoryData = state => getCurrentState(state).queryHistoryData;
